import { PricetagIcon } from '#app/components/icons'

export default {
	name: 'Offchain Sale',
	slug: 'offchainSale',
	description: 'Record sales that occurred off the blockchain',
	version: '1.0.0',
	icon: <PricetagIcon />,
	countersign: 'Optional',
	fields: [
		{
			name: 'Date',
			slug: 'date',
			required: true,
			type: 'date',
			placeholder: 'Select a Date',
		},
		{
			name: 'Receiver Address',
			slug: 'receiverAddress',
			required: true,
			type: 'text',
			placeholder: 'The Address of the Receiver',
		},
		{
			name: 'Owner Address',
			slug: 'ownerAddress',
			required: true,
			type: 'text',
			placeholder: 'The Address of the Owner',
		},
		{
			name: 'Amount',
			slug: 'amount',
			required: false,
			type: 'number',
			fieldMin: 0,
			fieldStep: 0.000000000000000001,
			placeholder: 'An amount associated with this event',
		},
		{
			name: 'Currency',
			slug: 'currency',
			required: false,
			type: 'text',
			placeholder: 'The currency for the above amount',
		},
		{
			name: 'Transaction Hash',
			slug: 'transactionHash',
			required: false,
			type: 'text',
			placeholder: 'The Transaction Hash of the Sale',
		},
		{
			name: 'URL',
			slug: 'url',
			required: false,
			type: 'text',
			placeholder: 'The URL for the Transaction',
		},
		{
			name: 'Countersign Required',
			slug: 'countersignRequired',
			required: false,
			type: 'boolean',
			hidden: true,
			placeholder: 'Does this require a countersign?',
		},
		{
			name: 'Description',
			slug: 'description',
			required: false,
			type: 'text',
			placeholder: 'A description of the offchain sale',
		},
	],
	info: '',
}
